<template>
    <v-btn flat icon
        class="icon-button"
        @click="emitButtonClick"
        :disabled="!enabled"
        :class="{ disabled: !enabled }">
        <base-base64-icon 
            v-if="type === 'base64'"
            :src="base64Icon" 
            :width="width" 
            :height="height" />
          <base-material-icon 
            v-if="type === 'materialIcon'"
            :iconName="materialIconName"
            :height="height" />
    </v-btn>
</template>

<script lang="ts">
import Vue from 'vue'

import BaseBase64Icon from '../base/BaseBase64Icon.vue'
import BaseMaterialIcon from '../base/BaseMaterialIcon.vue'

export enum IconButtonEvents {
    BUTTON_CLICKED = 'buttonClicked',
}

export default Vue.extend({
    name: 'IconButton',
    components: {
      BaseBase64Icon,
      BaseMaterialIcon,
    },
    props: {
        /**
         * the type of the icon base64 | materialIcon
         */
        type: {
          type: String,
          default : 'base64',
        },
        /**
         * the icon as base64 for string (complete with type)
         */
        base64Icon: {
          type: String,
          // tslint:disable:max-line-length
          default: 'data:image/svg+xml;base64,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',
          // tslint:enable:max-line-length
        },
        /**
         * the name of the material icon (for type materialIcon)
         */
        materialIconName: {
          type: String, 
          default: 'cancel',
        },
        /** 
         * determines if the button is enabled (if disabled, the click-event is not sent and the icon becomes an opacity of 0.4)
         */
        enabled: {
          type: Boolean,
          default: true,
        },
        /** 
         * determines the height (in pixel) of the icon
         */
        height: {
          type: Number,
          default: 100,
        },
        /** 
         * determines the width of the icon
         */
        width: {
          type: Number,
          default: 100,
        },
    },
    methods: {
        /**
         * Clicked event.
         *
         * @event buttonClicked
         */
        emitButtonClick(): void {
          if(this.enabled) {
            this.$emit('buttonClicked')
          }
        },
    },
})
</script>
<style lang="scss" scoped>
.icon-button {
  color: $fore-color-primary;
  font-family: $font-family-primary;
  outline: none;
  &.disabled {
    opacity: 0.4;
  }
}
</style>

<docs>
An icon button

The default icon button
```jsx
<icon-button />
```

Custom size 25px x 25px
```jsx
<icon-button 
  :width="25"
  :height="25" />
```

Disabled
```jsx
<icon-button
  :enabled="false"
  :width="25"
  :height="25" />
```

Example with click events handling
```js
new Vue({
  methods: {
    log(text) {
      console.log(text)
    }
  },
  template: `<icon-button
    type="materialIcon"
    name="add"
    @buttonClicked="() => log('clicked')"
    :width="25"
    :height="25" />`
})
```

Custom material icon
```jsx
<icon-button
  :type="'materialIcon'"
  :materialIconName="'clear'"
  :width="25"
  :height="25" />
```

Custom base64 string icon
```jsx
<icon-button
  :base64Icon="'data:image/svg+xml;base64,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'"
  :width="25"
  :height="25" />
```
</docs>
